import React from "react";
import PropTypes from "prop-types";

import SelectInput from "../../common/SelectInput";
import TextInput from "../../common/TextInput";
import Row from "../../common/Row";
import TextAreaInput from "../../common/TextAreaInput";
import * as domainConstants from "../../../constants/DomainConstants";
import DownloadUploadFiles from "../../common/DownloadUploadFiles";
import DateInput from "../../common/DateInput";
import convertToLabelValuePair from "../../../util/convertToLabelValuePair.js";

const AnderOnroerendZakelijkRechtAanvragerForm = (props) => {
    const {
        disabled,
        errors,
        langdurigZakelijkRechtTypes,
        aanvragers,
        onChange,
        minimaleEisen,
        color,
        mapDeleteFile,
        mapDropFiles,
        getFilesForDossierComponent,
        fileTypes,
        fileSessionStarted,
        defaultAanvrager,
        validationMessageType
    } = props;

    const langdurigZakelijkRechtTypesMapped = convertToLabelValuePair(langdurigZakelijkRechtTypes[minimaleEisen.jaargang]);
    const zakelijkRechtIdAndere = langdurigZakelijkRechtTypesMapped.find(l => l.label === domainConstants.LangdurigZakelijkRechtTypes.Andere).value;

    return (
        <Row>
            <Row>
                <SelectInput
                    label="Zakelijk recht"
                    name="zakelijkRechtId"
                    onChange={onChange}
                    value={minimaleEisen.zakelijkRechtId}
                    disabled={disabled}
                    size={minimaleEisen.zakelijkRechtId == zakelijkRechtIdAndere ? 6 : 12}
                    items={langdurigZakelijkRechtTypesMapped}
                    validationMessage={errors ? errors.zakelijkRechtId : ''}
                    validationMessageType={validationMessageType} />
                {minimaleEisen.zakelijkRechtId == zakelijkRechtIdAndere ?
                    <TextInput
                        label="Ander zakelijk recht"
                        name="motiveringSportVlaanderenHeeftAanvragerLangdurigZakelijkRecht"
                        onChange={onChange}
                        value={minimaleEisen.motiveringSportVlaanderenHeeftAanvragerLangdurigZakelijkRecht}
                        size={6}
                        disabled={disabled}
                        validationMessageType={validationMessageType}
                        validationMessage={errors ? errors.motiveringSportVlaanderenHeeftAanvragerLangdurigZakelijkRecht : ''}
                        maxLength={2000} />
                    : null}
            </Row>
            <Row>
                {defaultAanvrager === null ?
                    <SelectInput
                        label="Titularis"
                        name="titularisId"
                        onChange={onChange}
                        value={minimaleEisen.titularisId}
                        disabled={disabled}
                        items={aanvragers}
                        validationMessage={errors ? errors.titularisId : ''}
                        validationMessageType={validationMessageType} /> :
                    <SelectInput
                        label="Titularis"
                        name="titularisId"
                        onChange={onChange}
                        value={minimaleEisen.titularisId}
                        disabled={disabled}
                        items={[]}
                        defaultItem={defaultAanvrager.label}
                        validationMessage={errors ? errors.titularisId : ''}
                        validationMessageType={validationMessageType} />}
            </Row>
            <Row>
                <DateInput
                    label="Startdatum"
                    name="startdatumZakelijkRecht"
                    value={minimaleEisen.startdatumZakelijkRecht}
                    size={6}
                    disabled={disabled}
                    onChange={onChange}
                    validationMessage={errors ? errors.startdatumZakelijkRecht : ''}
                    validationMessageType={validationMessageType} />
                <DateInput
                    label="Einddatum"
                    name="einddatumZakelijkRecht"
                    value={minimaleEisen.einddatumZakelijkRecht}
                    size={6}
                    disabled={disabled}
                    onChange={onChange}
                    validationMessage={errors ? errors.einddatumZakelijkRecht : ''}
                    validationMessageType={validationMessageType} />
            </Row>
            <Row>
                <TextAreaInput
                    name="toelichtingAnderOnroerendZakelijkRecht"
                    label="Toelichting ander onroerend zakelijk recht"
                    value={minimaleEisen.toelichtingAnderOnroerendZakelijkRecht}
                    onChange={onChange}
                    size={12}
                    height={3}
                    disabled={disabled}
                    validationMessage={errors ? errors.toelichtingAnderOnroerendZakelijkRecht : ''}
                    validationMessageType={validationMessageType}
                    maxLength={4000} />
            </Row>
            <Row>
                <DownloadUploadFiles
                    dossierId={minimaleEisen.dossierId}
                    infrastructuurId={minimaleEisen.infrastructuur.id}
                    title="Bewijs van zakelijk recht"
                    center
                    disabled={disabled}
                    color={color}
                    tab={domainConstants.DocumentTab.MinimaleEisen}
                    component={domainConstants.ComponentName.BewijsZakelijkRecht}
                    onDelete={mapDeleteFile(domainConstants.ComponentName.BewijsZakelijkRecht)}
                    onDrop={mapDropFiles(domainConstants.ComponentName.BewijsZakelijkRecht)}
                    files={getFilesForDossierComponent(domainConstants.ComponentName.BewijsZakelijkRecht)}
                    fileTypes={fileTypes.BewijsZakelijkRecht}
                    validationMessage={errors ? errors.ulZakelijkRecht : ''}
                    validationMessageType={validationMessageType}
                    fileSessionStarted={fileSessionStarted} />
            </Row>
        </Row>
    );
};

// ----------------------------------------------------------------------------
AnderOnroerendZakelijkRechtAanvragerForm.propTypes = {
    disabled: PropTypes.bool,
    errors: PropTypes.object,
    langdurigZakelijkRechtTypes: PropTypes.arrayOf(PropTypes.object),
    aanvragers: PropTypes.arrayOf(PropTypes.object),
    onChange: PropTypes.func,
    minimaleEisen: PropTypes.object.isRequired,
    color: PropTypes.string.isRequired,
    mapDeleteFile: PropTypes.func,
    mapDropFiles: PropTypes.func,
    getFilesForDossierComponent: PropTypes.func,
    fileTypes: PropTypes.object,
    fileSessionStarted: PropTypes.bool.isRequired,
    defaultAanvrager: PropTypes.object,
    validationMessageType: PropTypes.string
};

export default AnderOnroerendZakelijkRechtAanvragerForm;
